'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  flex: '-ms-flexbox',
  'inline-flex': '-ms-inline-flexbox'
};

var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msPreferredSize'
};

var properties = Object.keys(alternativeProps).concat('display');

exports['default'] = function (property, value, _ref2, styles) {
  var browser = _ref2.browser;
  var version = _ref2.version;

  if (properties.indexOf(property) > -1 && (browser === 'ie_mob' || browser === 'ie') && version == 10) {
    delete styles[property];
    return _defineProperty({}, alternativeProps[property] || property, alternativeValues[value] || value);
  }
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ../~/inline-style-prefixer/lib/plugins/flexboxIE.js
 ** module id = 245
 ** module chunks = 0
 **/